'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaptchaCallNames = exports.ClassPath = exports.MethodName = undefined;
exports.needToReloadPageForCaptcha = needToReloadPageForCaptcha;
exports.isCaptchaExpectedBehavior = isCaptchaExpectedBehavior;

var _Language = require('./Language');

var MethodName = exports.MethodName = {
  Get: 'GET',
  Post: 'POST'
};

var ClassPath = exports.ClassPath = {
  User: 'user'
};

var CaptchaCallNames = exports.CaptchaCallNames = {
  CreateAccount: { methodPath: 'userpassCreate', classPath: ClassPath.User, method: MethodName.Post },
  EmailExists: { methodPath: 'emailExists', classPath: ClassPath.User, method: MethodName.Get },
  FacebookLogin: { methodPath: 'facebookLogin', classPath: ClassPath.User, method: MethodName.Post },
  ForgotPassword: { methodPath: 'forgotPassword', classPath: ClassPath.User, method: MethodName.Post },
  Login: { methodPath: 'userpassLogin', classPath: ClassPath.User, method: MethodName.Post }
};

function needToReloadPageForCaptcha(initLang, lang) {
  var value = initLang !== lang;
  if (value) {
    (0, _Language.updateLanguageByReload)(lang);
  }
  return value;
}

function isCaptchaExpectedBehavior(response, changeCaptchaRequired, initLang, lang) {
  if (response.captchaExpected) {
    // If we need to reload the page to correctly show the captcha (current language)
    if (!needToReloadPageForCaptcha(initLang, lang)) {
      changeCaptchaRequired(response.captchaExpected);
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Captcha.js
// module id = 167
// module chunks = 0